import { InputPadrao, InputDatePicker, InputTelefone } from '../../../../components/Inputs'
import { InputAtividadeEconomica, InputBeneficiarioTitular, InputEmpresaParceira, InputEstado, InputEstadoCivil, InputGrauDependencia, InputGrauInstrucao, InputMunicipio, InputOperadoraSaude, InputPais, InputPessoaJuridicaTipo, InputRaca, InputSexo } from '../../../../components/InputsAutoComplete'
import React, { useState, useEffect } from 'react'
import Yup, { validaCNPJ, validaCPF, validaData } from '../../../../util/Validacoes'
import { HeaderCadastro } from '../../../../components/Headers'
import { mostrarToast } from '../../../../components/Toasts'
import { Formik, Form } from 'formik'
import { BotaoPadrao } from '../../../../components/Botoes'
import { ajustarDadosTelefone, buscarCep, mensagens } from '../../../../util/Utilitarios'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { salvar, get } from '../../../../util/AcessoApi'
import '../../../../assets/css/icones/iconsmind/style.css';
import Atalho from '../../../../util/Atalho'

const CadastroPaciente = (props) => {
    let { id } = useParams()

    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({})

    const [validacao] = useState(Yup.object({
        nome_fantasia: Yup.string().required().nullable().trim(),
        razao_social: Yup.string().required().nullable().trim(),
        inscricao_municipal: Yup.string().required().nullable().trim(),
        atividade_economica: Yup.string().nullable().required(),
        data_admissao: Yup.string().nullable().max(200).trim()
            .test('Data Admissão', 'Data inválida!', function (value) { return validaData(this.parent.data_admissao) }),
        cnpj: Yup.string().test('CNPJ', 'CNPJ inválido!', function (value) { return validaCNPJ(this.parent.cnpj) })
            .nullable()
            .max(20).required(),

    }))
    const manter = []

    const Submit = (values, propsFormik) => {
        setSalvando(true)
        salvar(
            { ...values },
            '/faturamento/cooperadopj',
            obj => {
                mostrarToast('sucesso', mensagens.sucesso)
                if (salvarENovo) {
                    propsFormik.resetForm({})
                    manter.forEach(x => propsFormik.setFieldValue(x, values[x]))
                    setSalvando(false)
                }
                else {
                    props.history.push('/faturamento/cooperadopj/consulta')
                }
            },
            () => setSalvando(false))
    }

    useEffect(_ => {
        if (id)
            Promise.resolve(get(`/faturamento/cooperadopj/${id}`)).then(obj => {
                if (id && !obj.id)
                    props.history.push('/faturamento/cooperadopj/consulta')
                setValoresIniciais(obj)
            })
        else {
            setValoresIniciais({
                nome_fantasia: '',
                razao_social: '',
                inscricao_municipal: '',
                cnpj: ''
            })
        }
    }, [id])

    return (
        <Formik
            initialValues={valoresIniciais}
            validationSchema={validacao}
            enableReinitialize={true}
            onSubmit={(values, propsFormik) => Submit(values, propsFormik)}>
            {propsFormik => {
                return (<Form>
                    <div className={props.modal && props.modal || 'card mb-20'}>
                        <div className={props.modal || 'card-body'}>
                            <div className='row'>
                                <InputPadrao label='Id' name='id' type='hidden' placeholder='Id' />

                                {/* Razão Social */}
                                <InputPadrao obrigatorio={true} label='Razão Social' name='razao_social' type='text' placeholder='Razão Social' tamanho={'col-sm-12 col-lg-6 col-xl-5'} salvarENovo={salvarENovo} />

                                {/* Nome de Fantasia */}
                                <InputPadrao obrigatorio={true} label='Nome de Fantasia' name='nome_fantasia' type='text' placeholder='Nome de Fantasia' tamanho={'col-sm-12 col-lg-6 col-xl-5'} salvarENovo={salvarENovo} />

                                {/* Telefone */}
                                <InputPadrao mascaraTelefone={true} label='Telefone' name='telefone' type='text' placeholder='Telefone' tamanho={'col-sm-12 col-lg-6 col-xl-2'} salvarENovo={salvarENovo} />

                                {/* Fax */}
                                <InputPadrao mascaraTelefone={true} label='Fax' name='fax' type='text' placeholder='Fax' tamanho={'col-sm-12 col-lg-6 col-xl-2'} salvarENovo={salvarENovo} />

                                {/* Número do CNPJ */}
                                <InputPadrao label='CNPJ' name='cnpj' type='text' placeholder='CNPJ' tamanho={'col-sm-12 col-lg-6 col-xl-3'} salvarENovo={salvarENovo} mascara="11.111.111/1111-11" />

                                {/* E-mail */}
                                <InputPadrao label='E-mail' name='email' type='text' placeholder='E-mail' tamanho={'col-sm-12 col-lg-6 col-xl-4'} salvarENovo={salvarENovo} />

                                {/* Gerente Administrativo */}
                                <InputPadrao label='Gerente Administrativo' name='gerente_administrativo' type='text' placeholder='Gerente Administrativo' tamanho={'col-sm-12 col-lg-6 col-xl-3'} salvarENovo={salvarENovo} />

                                {/* Gerente Financeiro */}
                                <InputPadrao label='Gerente Financeiro' name='gerente_financeiro' type='text' placeholder='Gerente Financeiro' tamanho={'col-sm-12 col-lg-6 col-xl-3'} salvarENovo={salvarENovo} />

                                {/* Atividade Econômica */}
                                <InputAtividadeEconomica obrigatorio={true} label="Atividade Econômica" name="atividade_economica" placeholder="Atividade Econômica" propsFormik={propsFormik} tamanho='col-sm-12 col-lg-4 col-xl-3' />

                                {/* Inscrição Municipal */}
                                <InputPadrao obrigatorio={true} label='Inscrição Municipal' name='inscricao_municipal' type='text' placeholder='Inscrição Municipal' tamanho={'col-sm-12 col-lg-6 col-xl-3'} salvarENovo={salvarENovo} />

                                {/* Inscrição Estadual */}
                                <InputPadrao label='Inscrição Estadual' name='inscricao_estadual' type='text' placeholder='Inscrição Estadual' tamanho={'col-sm-12 col-lg-6 col-xl-3'} salvarENovo={salvarENovo} />

                                {/* E-mail envio Nota Fiscal */}
                                <InputPadrao label='E-mail envio Nota Fiscal' name='email_envio_nota_fiscal' type='text' placeholder='E-mail envio Nota Fiscal' tamanho={'col-sm-12 col-lg-6 col-xl-4'} salvarENovo={salvarENovo} />

                                {/* CNES */}
                                <InputPadrao label='CNES' name='cnes' type='text' placeholder='CNES' tamanho={'col-sm-12 col-lg-6 col-xl-3'} salvarENovo={salvarENovo} />

                                {/* Código da Operadora (ANS) */}
                                <InputPadrao label='Código da Operadora (ANS)' name='codigo_operadora' type='text' placeholder='Código da Operadora (ANS)' tamanho={'col-sm-12 col-lg-6 col-xl-3'} salvarENovo={salvarENovo} />

                                {/* Data Admissão */}
                                <InputDatePicker tamanho={"col-sm-12 col-lg-6 col-md-7 col-xl-3"} label="Data Admissão" name="data_admissao" type="text"
                                    setarValor={value => {
                                        propsFormik.setFieldValue("data_admissao", value)
                                    }} />

                                {/* Pessoa Jurídica Tipo */}
                                <InputPessoaJuridicaTipo label="Pessoa Jurídica Tipo" name="pessoa_juridica_tipo" placeholder="Pessoa Jurídica Tipo" propsFormik={propsFormik} tamanho='col-sm-12 col-lg-4 col-xl-3' obrigatorio={true} />
                                <Atalho formik={propsFormik} salvando={salvando} setSalvareNovo={setSalvarENovo} salvarENovo={true} />
                            </div>
                        </div>
                    </div>
                    <div className='separator mt-40 mb-5'></div>
                    <div className='direita container-botoes mb-3 group-salvar-novo'>
                        <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => setSalvarENovo(false)} idTooltip={'salvar'} />
                        {(props.modal || !id) && <BotaoPadrao texto='Salvar e Novo' disabled={salvando} click={_ => setSalvarENovo(true)} idTooltip={'salvarENovo'} />}
                    </div>
                </Form>)
            }}
        </Formik>
    )
}

const Cadastro = (props) => {
    const links = [
        () => <Link to={'/dashboard'}>Dashboard</Link>,
        () => <span>faturamento</span>,
        () => <Link className='link-active' to={'/faturamento/cooperadopj/consulta'}>Cooperado PJ</Link>,
    ]
    return (<>
        {<HeaderCadastro titulo={"Cadastro Cooperado PJ"} link={links} />}
        <CadastroPaciente {...props} />
    </>
    )
}
export { CadastroPaciente }
export default Cadastro